<template>
  <div>
    <div class="specification-wrapper">
      <div class="d-flex align-items-center mb-3" style="gap: 0.5rem">
        <div>
          <img src="~@/assets/icon/chip-blue.svg" alt="verified" width="24" />
        </div>
        <h5 class="section-title mb-0">Performance</h5>
      </div>
      <div class="d-flex" style="gap: 1rem">
        <div class="w-100">
          <input-text
            id="processor"
            label="Processor"
            :value="forms.productDetail.processor"
            placeholder="e.g. Intel Core i7-12700H"
            @change="(val) => $emit('handleChangeInput', 'productDetail.processor', val)"
            :error="
              (errors &&
                errors.productDetail &&
                errors.productDetail.processor) ||
              null
            "
            :disabled="!!catalogId"
          />
        </div>
        <div class="w-100">
          <input-text
            id="battery"
            label="Battery"
            :value="forms.productDetail.battery"
            placeholder="e.g. NVIDIA GTX 1650"
            @change="(val) => $emit('handleChangeInput', 'productDetail.battery', val)"
            showSuffixLabel
            :error="
              (errors && errors.productDetail && errors.productDetail.battery) ||
              null
            "
            :disabled="!!catalogId"
          >
          <template #suffix-label>mAh</template>
        </input-text>
        </div>
      </div>
    </div>
    <br />
    <div class="specification-wrapper">
      <div class="d-flex align-items-center mb-3" style="gap: 0.5rem">
        <div>
          <img src="~@/assets/icon/memory-green.svg" alt="verified" width="24" />
        </div>
        <h5 class="section-title mb-0">Memory</h5>
      </div>
      <div class="d-flex" style="gap: 1rem">
        <div class="w-100">
          <input-text
            id="ram"
            label="RAM"
            :value="forms.productDetail.ram"
            placeholder="e.g. 4"
            @change="(val) => $emit('handleChangeInput', 'productDetail.ram', val)"
            showSuffixLabel
            :error="
              (errors && errors.productDetail && errors.productDetail.ram) ||
              null
            "
            :disabled="!!catalogId"
          >
          <template #suffix-label>GB</template>
        </input-text>
        </div>
        <div class="w-100">
          <input-text
            id="storage"
            label="Storage"
            type="number"
            :value="forms.productDetail.storage"
            placeholder="e.g. 256"
            @change="(val) => $emit('handleChangeInput', 'productDetail.storage', val)"
            showSuffixLabel
            :error="
              (errors && errors.productDetail && errors.productDetail.storage) ||
              null
            "
            :disabled="!!catalogId"
          >
          <template #suffix-label>GB</template>
        </input-text>
        </div>
      </div>
    </div>
    <br />
    <div class="specification-wrapper">
      <div class="d-flex align-items-center mb-3" style="gap: 0.5rem">
        <div>
          <img src="~@/assets/icon/orange-camera.svg" alt="verified" width="24" />
        </div>
        <h5 class="section-title mb-0">Camera</h5>
      </div>
      <div class="d-flex" style="gap: 1rem">
        <div class="w-100">
          <input-text
            id="rear-camera"
            label="Rear Camera"
            :value="forms.productDetail.mainCamera"
            placeholder="e.g. 200MP Main, 48MP Ultra-Wide"
            @change="(val) => $emit('handleChangeInput', 'productDetail.mainCamera', val)"
            :error="
              (errors &&
                errors.productDetail &&
                errors.productDetail.mainCamera) ||
              null
            "
            :disabled="!!catalogId"
          />
        </div>
        <div class="w-100">
          <input-text
            id="front-camera"
            label="Front Camera"
            :value="forms.productDetail.frontCamera"
            placeholder="e.g. 16MP Wide Angle"
            @change="(val) => $emit('handleChangeInput', 'productDetail.frontCamera', val)"
            :error="
              (errors &&
                errors.productDetail &&
                errors.productDetail.frontCamera) ||
              null
            "
            :disabled="!!catalogId"
          />
        </div>
      </div>
    </div>
    <br />
    <div class="specification-wrapper">
      <div class="d-flex align-items-center mb-3" style="gap: 0.5rem">
        <div>
          <img
            src="~@/assets/icon/desktop-purple.svg"
            alt="verified"
            width="24"
          />
        </div>
        <h5 class="section-title mb-0">Display</h5>
      </div>
      <div class="d-flex" style="gap: 1rem">
        <div class="w-50">
          <input-text
            id="screen"
            label="Screen"
            :value="forms.productDetail.screen"
            placeholder="e.g. 15.6"
            showSuffixLabel
            @change="(val) => $emit('handleChangeInput', 'productDetail.screen', val)"
            :error="
              (errors && errors.productDetail && errors.productDetail.screen) ||
              null
            "
            :disabled="!!catalogId"
          >
            <template #suffix-label>inch</template>
          </input-text>
        </div>
      </div>
    </div>
    <br>
    <div class="specification-wrapper">
      <input-textarea
        id="features"
        :value="forms.productDetail.feature"
        placeholder="List the features of this product"
        label="Features"
        @change="(val) => $emit('handleChangeInput', 'productDetail.feature', val)"
        :error="(errors && errors.productDetail && errors.productDetail.feature) || null"
        :disabled="!!catalogId"
      />
    </div>
  </div>
</template>

<script>
import {
  SingleSelect,
  InputText,
  InputTextarea,
  InputRadio,
} from "../../../Input";

export default {
  name: "SmartphoneAndTablet",
  components: {
    SingleSelect,
    InputText,
    InputTextarea,
    InputRadio,
  },
  props: {
      errors: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      forms: {
        type: Object,
        required: true,
      },
  },
  data() {
    return {
      memoryTypeOptions: [
        { label: "Removable", value: "removable" },
        { label: "Onboard", value: "onboard" },
      ],
    };
  },
  computed: {
    catalogId() {
      const id = Number(this.$route.params.id)
      return isNaN(id) ? 0 : id;
    }
  },
};
</script>

<style scoped>
.section-title {
  font-weight: 700;
  font-size: 1.125rem;
  margin-bottom: 0.5rem;
}

.section-description {
  font-weight: 400;
  font-size: 0.875rem;
}

.specification-wrapper {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 0.5rem;
}

.bg-white {
  background: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/Catalog/Components/TechSpec/SmartphoneAndTablet.vue